import React, { createContext, useContext } from 'react';

interface PageContextType {
  currentPageSlug: string;
}

const PageContext = createContext<PageContextType | undefined>(undefined);

export const usePage = () => {
  const context = useContext(PageContext);
  if (!context) throw new Error("usePage must be used within a PageProvider");
  return context;
};

export const PageProvider = ({
  currentPageSlug,
  children,
}: {
  currentPageSlug: string;
  children: React.ReactNode;
}) => {
  return (
    <PageContext.Provider value={{ currentPageSlug }}>
      {children}
    </PageContext.Provider>
  );
};